import { Component, OnInit } from '@angular/core';
import { IErrorDescription } from '@ibank-globals/error';
import { LanguageService } from '@ibank-globals/language';
import { finalize } from 'rxjs/operators';
import { BaseComponent } from '../../../globals/classes/base.component';
import { ErrorHandler } from '../../../globals/classes/errorHandler';
import { FaqSection } from '../../classes/http-responses';
import { Constants } from '../../classes/static/constants';
import { FAQsService } from '../../services/faqs.service';
import {
	ICachedFaqSection,
	SwitchCode,
} from '../common-questions/common-questions-section/switch-code';

@Component({
	selector: 'faqs',
	template: require('./faqs.component.html'),
})
export class FaqsComponent extends BaseComponent implements OnInit {
	constructor(private _langSvc: LanguageService) {
		super();
	}
	public isLoading: boolean = false;
	public isCorporate: boolean = false;
	public userType: string = Constants.Retail_Type;
	public faqSections: FaqSection[];
	public cacheFaqSections: ICachedFaqSection[] = [];
	public cacheFaqSection: ICachedFaqSection;
	public items: SwitchCode[] = [
		{ name: 'Ιδιώτες', code: 0, userType: Constants.Retail_Type },
		{
			name: 'Επιχειρήσεις',
			code: 1,
			userType: Constants.Corporate_Type,
		},
	];

	private _lang: string;

	public ngOnInit(): void {
		this._initSubscriptions();
	}

	public tabClicked(tabCode: number): void {
		if (tabCode === 1) {
			this.isCorporate = true;
			this.userType = Constants.Corporate_Type;
		} else {
			this.isCorporate = false;
			this.userType = Constants.Retail_Type;
		}
		this.loadFaqs(this._lang);
	}

	private _initSubscriptions() {
		this.mortalize(this._langSvc.activeLanguage$).subscribe((lang) => {
			this._lang = lang;
			this.loadFaqs(lang);
		});
	}

	private loadFaqs(lang: string) {
		var existingCacheEntry = this.cacheFaqSections.find(
			(ci) => ci.lang == this._lang && ci.userType == this.userType
		);
		if (!!existingCacheEntry) {
			this.faqSections = [...existingCacheEntry.faqSections];
		} else {
			this.loadFaqsFromApi(lang);
		}
	}

	private loadFaqsFromApi(lang: string) {
		this.isLoading = true;
		FAQsService.getFaqSections(lang, this.userType)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe(
				(faqSectionsFromApi) => {
					this.handleFaqSectionResponse(faqSectionsFromApi);
				},
				(error) => this.handleFaqsError(error)
			);
	}

	private handleFaqSectionResponse(faqSections: FaqSection[]): void {
		this.faqSections =
			faqSections == null
				? []
				: [...faqSections.filter((s) => !!s.faqs && s.faqs.length > 0)];
		this.updateCache(this.faqSections);
	}

	private updateCache(faqSections: FaqSection[]) {
		this.cacheFaqSection = this.cacheFaqSections.find(
			(ci) => ci.lang == this._lang && ci.userType == this.userType
		);
		if (!!this.cacheFaqSection) {
			this.faqSections = this.cacheFaqSection.faqSections;
		} else {
			this.cacheFaqSections.push({
				userType: this.userType,
				faqSections: faqSections,
				lang: this._lang,
			});
		}
	}

	private handleFaqsError(error: IErrorDescription) {
		ErrorHandler.newError(error);
	}
}
